export default __webpack_public_path__ + "static/media/EuclidSquare-Bold.22d0be7b.woff";